import type { AnyAction } from "redux";
import * as actionTypes from "../../action_types/users_filters_selection_action_types";

export type FilterSelectionEntity = {
    selectedWebSource?: string;
    selectedCountry?: string;
    selectedDuration?: string | number;
    filterChangeEducationalTooltipPresented: boolean;
};

function getDefaultState() {
    return {
        selectedWebSource: undefined,
        selectedCountry: undefined,
        selectedDuration: undefined,
        filterChangeEducationalTooltipPresented: false,
    };
}

export function usersFiltersSelection(state = getDefaultState(), action: AnyAction) {
    switch (action.type) {
        case actionTypes.COUNTRY_SELECTION: {
            return { ...state, selectedCountry: action.selectedCountry };
        }
        case actionTypes.DURATION_SELECTION: {
            return { ...state, selectedDuration: action.selectedDuration };
        }
        case actionTypes.EDUCATIONAL_FILTER_WAS_PRESENTED: {
            return {
                ...state,
                filterChangeEducationalTooltipPresented: true,
            };
        }
        default:
            return state;
    }
}
